import { connect } from "react-redux";
import { ReduxState } from "../../store/state";
import NavBar from "../../components/navigation/NavBar";
import {
  Container,
  Text,
  Switch,
  Flex,
  Divider,
  Box
} from '@chakra-ui/react'
import { User } from "../../store/user/types";
import { MdHistory, MdSearch, MdShoppingCart, MdTrendingUp } from "react-icons/md";
import { useEffect } from "react";
import { fetchPreviouslyPurchasedItems, fetchPreviouslyViewedItems, fetchTrendingItems, fetchQueriedItems } from "../../store/page/initiators";
import { BusinessItem, ItemsQuery } from "../../store/page/types";
import MiniItemGrid from "../../components/page/MiniItemGrid";
import MiniItemRow from "../../components/page/MiniItemRow";
import { updateItemsQuery } from "../../store/page/actions";
import Footer from "../../components/navigation/Footer";
import { Helmet } from "react-helmet";

interface HomePageProps {
  user: User | null;
  previouslyViewedItems: BusinessItem[];
  previouslyPurchasedItems: BusinessItem[];
  trendingItems: BusinessItem[];
  queriedItems: BusinessItem[];
  itemsQuery: ItemsQuery;
  fetchPreviouslyViewedItems: () => void;
  fetchPreviouslyPurchasedItems: () => void;
  fetchTrendingItems: () => void;
  updateItemsQuery: (update: ItemsQuery) => void;
  fetchQueriedItems: (more: boolean) => void;
}

const HomePage: React.FC<HomePageProps> = ({ 
  user, previouslyViewedItems, previouslyPurchasedItems, trendingItems, itemsQuery, queriedItems,
  fetchPreviouslyViewedItems, fetchPreviouslyPurchasedItems, fetchTrendingItems, updateItemsQuery,
  fetchQueriedItems 
}) => {
  
  useEffect(() => {
      // Redirect to the external URL with the pageKey
      window.location.href = `https://www.goshowfa.com/p`;
  }, []);

  // useEffect(() => {
  //   if (user) {
  //     fetchPreviouslyViewedItems();
  //     fetchPreviouslyPurchasedItems();
  //   }
  //   fetchTrendingItems()
  // }, [user])
  
  const renderHomePage = () => {
    return (
      <Box bg={'gray.50'}>
        <Container maxW={'8xl'} pt={1}>
          <Helmet>
            <title>{`Showfa Express Pages: Request. Deliver. Impress.`}</title>
            <meta name="description" content={`Showfa Express Pages: Request. Deliver. Impress.`} />
            <meta property="og:title" content={`Showfa Express Pages: Request. Deliver. Impress.`} />
            <meta property="og:description" content={`Showfa Express Pages: Request. Deliver. Impress.`} />
            <meta property="og:url" content={`/`} />
            <meta property="og:site_name" content="Showfa Express Pages" />
          </Helmet>
          <Flex mt={2} ml={7} flexDirection={'row'} alignItems={'center'}>
            <Switch colorScheme="red" isChecked={itemsQuery.freeDelivery} onChange={() => {
              updateItemsQuery({...itemsQuery, freeDelivery: !itemsQuery.freeDelivery})
              fetchQueriedItems(false)
            }
              }></Switch>
            <Text ml={2} fontSize={'sm'} color={'gray.600'}>Free Delivery</Text>
          </Flex>
          { itemsQuery.search.length > 2 ? (
            <>
            <Flex direction={'row'} alignItems={'center'} pt={2}>
              <MdSearch color="gray.600"/>
              <Text textAlign={'right'} fontWeight={'bold'} color={'gray.600'} ml={2}>
                { queriedItems.length 
                ? `Search results for "${itemsQuery.search}"`
                : `Nothing found matching "${itemsQuery.search}"`
                }
                
              </Text>
            </Flex>
            <Divider></Divider>
            <MiniItemGrid items={queriedItems.filter((item: BusinessItem) => (item.status === 'active' && item.pageData?.status === 'active'))}/>
            </>
          ) : null}
          <Flex direction={'row'} alignItems={'center'} pt={2}>
            <MdTrendingUp color="#CA0000"/>
            <Text textAlign={'right'} fontWeight={'bold'} color={'#CA0000'} ml={2}>Trending</Text>
          </Flex>
          <Divider></Divider>
          <MiniItemGrid items={trendingItems.filter((item: BusinessItem) => (item.status === 'active' && item.pageData?.status === 'active'))}/>
          { previouslyViewedItems.length ? (
            <>
            <Flex direction={'row'} alignItems={'center'} pt={2}>
              <MdHistory color="gray.600"/>
              <Text textAlign={'right'} fontWeight={'bold'} color={'gray.600'} ml={2}>Remember These</Text>
            </Flex>
            <Divider></Divider>
            <MiniItemRow items={previouslyViewedItems.filter((item: BusinessItem) => (item.status === 'active' && item.pageData?.status === 'active'))} xs={true}/>
            </>
          ) : null}
          { previouslyPurchasedItems.length ? (
            <>
            <Flex direction={'row'} alignItems={'center'} pt={2}>
              <MdShoppingCart color="gray.600"/>
              <Text textAlign={'right'} fontWeight={'bold'} color={'gray.600'} ml={2}>Buy Again</Text>
            </Flex>
            <Divider></Divider>
            <MiniItemRow items={previouslyPurchasedItems.filter((item: BusinessItem) => (item.status === 'active' && item.pageData?.status === 'active'))} xs={true}/>
            </>
          ): null}
        </Container>
      </Box>
    )
  }

  return (
    <>
    {/* <NavBar suppressSearchDisplay={true} /> */}
    {/* {renderHomePage()} */}
    {/* <Footer /> */}
    </>
  );
}

const mapStateToProps = (state: ReduxState) => {
  const { user } = state.user;
  const { previouslyViewedItems, previouslyPurchasedItems, trendingItems, queriedItems, itemsQuery } = state.page;
  return { user, previouslyViewedItems, previouslyPurchasedItems, trendingItems, queriedItems, itemsQuery };
};

export default connect(mapStateToProps, {
  fetchPreviouslyViewedItems,
  fetchPreviouslyPurchasedItems,
  fetchTrendingItems,
  updateItemsQuery,
  fetchQueriedItems
})(HomePage);

